import {NfGlobalMessage} from "../NfGlobalMessage";
import {NfMessage, NfMessageType} from "../NfMessage";

export class ServiceWorkerActivated extends NfGlobalMessage {
    public constructor(props?: MessageEvent<ServiceWorkerActivated>) {
        super(NfMessageType.ServiceWorkerActivated, !NfMessage.isMessageEvent(props));
        if (NfMessage.isMessageEvent(props)) {
            Object.assign(this, props.data);
        }
    }
}

NfMessage.creationCallbacks[NfMessageType.ServiceWorkerActivated] = (event) => {
    return new ServiceWorkerActivated(event);
};